"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck"),
    _classCallCheck3 = _interopRequireDefault(_classCallCheck2),
    _createClass2 = require("babel-runtime/helpers/createClass"),
    _createClass3 = _interopRequireDefault(_createClass2),
    Step = function () {
  function e(t) {
    var s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1e3;
    (0, _classCallCheck3.default)(this, e), this.after = s, this.name = t, this.chain = [];
  }

  return (0, _createClass3.default)(e, [{
    key: "push",
    value: function value(e) {
      this.start && (e.step = this.index, e.start = this.start), this.chain.push(e);
    }
  }]), e;
}();

exports.default = Step, module.exports = exports.default;